import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { CouponForm } from '@components/molecules/CouponForm';
import { Loader } from '@components/molecules/Pagination';
import { useData } from '@hooks/useData';

export const MyCouponsEdit: FC = () => {
    const { myCouponDetail, isLoadingMyCouponDetail } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('my-coupons-edit-component.title', { name: myCouponDetail?.data?.promo_code || '' }),
    };

    return (
        <MyAccountContainer title={translations.title}>
            <div className="pt-4">{isLoadingMyCouponDetail ? <Loader /> : <CouponForm edit={true} />}</div>
        </MyAccountContainer>
    );
};
